import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';
import { formatOptionalId } from './memberConstants';

export default function MemberRemarkModal({ open, row, onClose, onSaved }) {
  const [remark, setRemark] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open && row) {
      setRemark(row.remark || '');
      setError('');
      setSubmitting(false);
    }
  }, [open, row?.id, row?.remark]);

  if (!open || !row) {
    return null;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      await adminApi.memberUpdate({
        id: row.id,
        remark: remark.trim(),
      });
      onSaved?.();
      onClose?.();
    } catch (err) {
      setError(err.message || '更新失敗');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div className="admin-modal" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal__header">
          <h3>更新備註 [{formatOptionalId(row.id)}]</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="admin-modal__body">
            <p className="page-desc">
              用戶ID：
              {formatOptionalId(row.id)}
            </p>
            <div className="form-field">
              <label htmlFor="memberRemark">備註</label>
              <input
                id="memberRemark"
                type="text"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                disabled={submitting}
              />
            </div>
            {error && <div className="alert alert-error">{error}</div>}
          </div>
          <div className="admin-modal__footer">
            <button type="submit" className="btn btn-success" disabled={submitting}>
              {submitting ? '提交中…' : '提交'}
            </button>
            <button type="button" className="btn btn-warning" onClick={() => setRemark('')} disabled={submitting}>
              重置
            </button>
            <button type="button" className="btn btn-danger" onClick={onClose} disabled={submitting}>
              關閉
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
